import { useLoadImage } from 'src/app/shared/hooks/image';

import type { SuggestedPetition } from '../../../../../../../../shared/api';

const MAX_ATTEMPTS = 10;
const POLLING_TIME = 3 * 1000; // 3sec

/**
 * Returns:
 *  - empty string if the petition has no image
 * 	- undefined if the image is still loading
 *  - The image URL when image is loaded
 */
export const usePetitionImageUrl = (petition: SuggestedPetition): string | undefined => {
	const {
		node: { photo },
	} = petition;
	const finalPhoto = photo?.petitionSmall;
	const imageLoaded = useLoadImage(finalPhoto?.url, {
		maxAttempts: MAX_ATTEMPTS,
		pollingTime: POLLING_TIME,
		processing: finalPhoto?.processing,
	});

	if (!finalPhoto) {
		return '';
	}

	if (!imageLoaded) {
		return undefined;
	}

	return finalPhoto.url;
};
